const redirectList = [
  {
    domain: 'ALL',
    docroot: 'public_html',
    http_status_code: '301',
    redirect_www: 1,
    wildcard: 1,
    src: '/site1',
    type: 'permanent',
    url: 'http://newhpwp.com/',
  },
  {
    domain: 'azs.gnc.temp-bh.newfold-dev.site',
    docroot: 'public_html',
    http_status_code: '301',
    redirect_www: 1,
    wildcard: 1,
    src: '/site1',
    type: 'permanent',
    url: 'http://newhpwp.com/',
  },
  {
    domain: 'test-destiny-06aug-01.com',
    docroot: 'public_html',
    http_status_code: '302',
    redirect_www: 0,
    wildcard: 1,
    src: '/site1',
    type: 'temporary',
    url: 'http://newhpwp.com/',
  },
];

export default redirectList;
